import React from 'react';
import { ErrorBox } from '~/utils';

export function NotFound( props ) {
  return <ErrorBox error="Nothing here, somebody must have swiped it!" />;
}
